import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';

export default function AgentConfirmationPage() {
    const { token } = useParams();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        confirmConsent();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on token
    }, [token]);

    const confirmConsent = async () => {
        try {
            const response = await api.post('/public/confirm-agent', { token });
            if (response.data.success) {
                setStatus('success');
                setMessage(response.data.message);
            } else {
                setStatus('error');
                setMessage(response.data.error || 'Eroare necunoscută');
            }
        } catch (error) {
            console.error('Confirmation error:', error);
            setStatus('error');
            setMessage(error.response?.data?.error || 'Link-ul este invalid sau a expirat.');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Confirmare Acord GDPR
                </h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    {status === 'loading' && (
                        <div className="text-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                            <p className="text-gray-600">Se verifică consimțământul...</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="text-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">Multumim!</h3>
                            <p className="text-green-600 mb-6">{message}</p>
                            <p className="text-gray-500 text-sm">
                                Contul tău a fost activat. Acum vei apărea pe paginile alocate.
                            </p>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="text-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">Eroare</h3>
                            <p className="text-red-600 mb-6">{message}</p>
                            <p className="text-gray-500 text-sm">
                                Te rugăm să contactezi administratorul dacă problema persistă.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
